import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { "name": "परिचय ", "id": "about-diploma" },
    { "name": "समय सारिणी", "id": "timetable" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>आज सम्पूर्ण जगत वैदिकमन्त्रों के प्रभावों की वैज्ञानिकता एवम् आध्यात्मिकता को प्रत्यक्षीकृत करते हुए स्वीकार कर रहा है इसलिए वैदिकमन्त्रों के रहस्यों को जानने के लिए समस्त जगत उद्यत एवं तत्पर है। इसी भाव को लेकर विश्वविद्यालय के वेद डिप्लोमा विभाग वेदों में सन्निहित इष्ट - प्राप्ति के वैदिक उपायों को वेदोक्त एवं शास्त्रीय विधि से समुचित सुसम्पन्न किया जाता है, जिससे वैदिक परम्परा को संरक्षित एवं प्रतिष्ठित किया जा सके। विश्वविद्यालयीय वेद डिप्लोमा सर्वतोभावेन छात्रहित एवं समाज कल्याण के लिए कटीबद्ध एवं सङ्कल्पित है, जिससे निश्चय से ही विश्वविद्यालयीय छात्र व जनसमूह लाभान्वित होंगे। उपर्युक्त विषयों के आलोक में मीमांसित जो उद्देश्य हैं वे अधोलिखित हैं -</p>
            <ol>
                <li>वेद के माध्यम से सामाजिक सामाञ्जस्य की स्थापना करना ।</li>
                <li>वेद विहित व्रतोद्यापनादि के माध्यम से समाज में सकारात्मकता का संचार करना।</li>
                <li>वेदों में निहित यज्ञादि के माध्यम से सामाजिक शुद्धता का सम्पादन करना।</li>
                <li>वेद बोधित व्रतादि के माध्यम से शारीरिक सौष्ठता के द्वारा संगठित समाज का निर्माण करना।</li>
                <li>वैदिक संस्कार के द्वारा समुचित व्यक्तित्व का निर्माण करना।</li>
                <li>वैदिक सूक्तिज्ञान के द्वारा छात्रों में नैतिक तत्त्वों का अवधान करना।</li>
                <li>मन्त्रादि पाठ के द्वारा सकारात्मक उर्जा का संचार करना।</li>
                <li>वेद विषयक प्रमाणिक एवं शास्त्रीय ज्ञान को प्रतिष्ठापित करना।</li>
                <li>वेदोक्त उपायों के द्वारा समस्त समस्याओं का समाधान करना।</li>
            </ol>
        </>
    ),
    "timetable": (
        <>
            <p>सत्र प्रारम्भ के समय समय – सारणी प्रस्तुत कर दिया जाएगा।</p>
        </>
    ),
    "achievements": (
        <>
            <p>नूतन पाठ्यक्रम होने के कारण वर्तमान में कोई उपलब्धि नहीं है। विभाग के द्वारा पाठ्यक्रम प्रारम्भोत्तर कोई भी नव उपलब्धि होने पर यथासमय प्रस्तुत किया जाएगा।</p>
        </>
    ),
    "contact": (
        <>
            <p>डॉ. अखिलेश कुमार मिश्र</p>
            <p>समन्वयक - वेद डिप्लोमा</p>
            <p>सम्पर्कसूत्र – 7631274367</p>
            <p>ईमेल – akhimishra111@gmail.com</p>
        </>
    )
};

export default function VedaDiploma() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeId, setActiveId] = useState(departments[0].id); // Use id for active state
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]); // Set default content based on first department's ID

    // Effect to handle sidebar visibility on window resize for larger screens
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) { // Bootstrap's md breakpoint
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setActiveId(deptId);
        setCurrentContent(contentData[deptId]);
        // Close sidebar on item click for small screens only
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}>
                <h5 className="text-center fw-bold mb-3 text-dark">वेद डिप्लोमा</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            onClick={() => handleItemClick(dept.id)}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id ? "text-white" : "text-dark"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeId === dept.id ? "#77236b" : "white",
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto">
                <h5></h5>
                <div>{currentContent}</div> {/* Display content from state */}
            </main>
        </div>
    );
}